export default "__VITE_ASSET__gOmxg3sg__"